export default function StickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#001736]/80 backdrop-blur-xl border-t border-white/10 p-3" data-testid="mobile-sticky-cta">
      <button
        type="button"
        onClick={() => {}}
        className="cta-btn w-full"
        data-testid="mobile-sticky-cta-button"
      >
        ✓ RESERVE MY FREE SEAT
      </button>
    </div>
  );
}
